import React from "react";
import { AksiPerubahan } from "./AksiPerubahan";

export const informationConfig = [
    {
        path: '/apps/information/aksi-perubahan',
        element: <AksiPerubahan />
    },
   
];